<template>
  <the-editor/>
</template>

<script>
import TheEditor from '@/components/editor/TheEditor.vue';

export default {
  name: 'NoteEditor',
  components: {
    TheEditor,
  },
};
</script>
